import { createRouter, createWebHistory } from "vue-router";

const HomeView = () => import("../views/home/HomeView.vue");
const AboutUsView = () => import("../views/aboutus/AboutUsView.vue");
const ProductView = () => import("../views/product/ProductView.vue");
const ShoppingCartView = () =>
  import("../views/shoppingcart/ShoppingCartView.vue");
const CheckOrderView = () => import("../views/trackntrace/CheckOrderView.vue");
const OrderStatusView = () =>
  import("../views/trackntrace/OrderStatusView.vue");

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contactus",
    name: "contactus",
    redirect: "/#contactus",
  },
  {
    path: "/buynow",
    name: "buynow",
    redirect: "/#buynow",
  },
  {
    path: "/aboutus",
    name: "aboutUs",
    component: AboutUsView,
  },
  {
    path: "/product/:category/:productID",
    name: "product",
    component: ProductView,
  },
  {
    path: "/shoppingcart",
    name: "shoppingCart",
    component: ShoppingCartView,
  },
  {
    path: "/checkorder/:email?/:orderNumber?",
    name: "checkOrder",
    component: CheckOrderView,
  },
  {
    path: "/orderstatus/:email/:orderNumber",
    name: "orderStatus",
    component: OrderStatusView,
  },
  {
    path: "/:unexpectedPath(.*)",
    redirect: { name: "home" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((res) => {
        setTimeout(() => {
          res({ el: to.hash });
        }, 100);
      });
    }
  },
});

export default router;
